import React from 'react';
import { Accordion } from 'react-bootstrap';
import { ChevronRightIcon, ChevronDownIcon } from "@heroicons/react/outline";
import CollectionItem from './CollectionItem';
import './CollectionsListBox.scss';

const CollectionsListBox = props => {
  const [selectedIndex, setSelectedIndex] = React.useState(-1);
  const [selectedSharedIndex, setSelectedSharedIndex] = React.useState(-1);
  const [isOpenMyCollection, setIsOpenMyCollection] = React.useState(true);
  const [isOpenSharedCollection, setIsOpenSharedCollection] = React.useState(true);

  React.useEffect(() => {
    if (props.collection) {
      const findSelectedIndex = props.collections.filter(clt => clt.sharedBy === null || clt.sharedBy === undefined).findIndex(clt => clt.id === props.collection.id);
      const findSelectedSharedIndex = props.collections.filter(clt => clt.sharedBy !== null && clt.sharedBy !== undefined).findIndex(clt => clt.id === props.collection.id);

      setSelectedIndex(findSelectedIndex);
      setSelectedSharedIndex(findSelectedSharedIndex);
    } else {
      setSelectedIndex(-1);
      setSelectedSharedIndex(-1);
    }
  }, [props.collection]);

  React.useEffect(() => {
    if (props.collections && props.collection) {
      const findSelectedIndex = props.collections.filter(clt => clt.sharedBy === null || clt.sharedBy === undefined).findIndex(clt => clt.id === props.collection.id);
      const findSelectedSharedIndex = props.collections.filter(clt => clt.sharedBy !== null && clt.sharedBy !== undefined).findIndex(clt => clt.id === props.collection.id);

      setSelectedIndex(findSelectedIndex);
      setSelectedSharedIndex(findSelectedSharedIndex);
    }
  }, [props.collections]);

  const onClickItem = (index, collection) => {
    setSelectedSharedIndex(-1);

    if (index !== selectedIndex) {
      setSelectedIndex(index);
    } else {
      setSelectedIndex(-1);
    }

    props.onSelect(collection);
  }

  const onClickSharedItem = (index, collection) => {
    setSelectedIndex(-1);

    if (index !== selectedSharedIndex) {
      setSelectedSharedIndex(index);
    } else {
      setSelectedSharedIndex(-1);
    }

    props.onSelect(collection);
  }

  const onEditCollection = (e, index, collection) => {
    e.stopPropagation();
    
    setSelectedSharedIndex(-1);
    setSelectedIndex(index);
    props.onEditing(collection);
  }

  const onEditSharedCollection = (e, index, collection) => {
    e.stopPropagation();
    
    setSelectedIndex(-1);
    setSelectedSharedIndex(index);
    props.onEditing(collection);
  }

  return (
    <div className="collections-listbox">
      <Accordion defaultActiveKey="0">
        <Accordion.Toggle
          eventKey="0"
          className="w-100 accordion-toggle"
          onClick={() => setIsOpenMyCollection(!isOpenMyCollection)}
        >
          <div className="title d-flex px-2">
            <span>My Collections</span>
            {isOpenMyCollection ? <ChevronDownIcon className="icons" /> : <ChevronRightIcon className="icons" />}
          </div>
        </Accordion.Toggle>
        <Accordion.Collapse eventKey="0">
          <div>
            {
              props.collections
                .filter(clt => clt.sharedBy === null || clt.sharedBy === undefined)
                .map((collection, index) =>
                  <CollectionItem
                    key={`collection_${index}`}
                    collection={collection}
                    site={props.sites.find(site => site.collectionId === collection.id)}
                    onClick={() => onClickItem(index, collection)}
                    onEdit={(e) => onEditCollection(e, index, collection)}
                    selected={index === selectedIndex}
                    Analytics={props.Analytics}
                  />
                )
            }
          </div>
        </Accordion.Collapse>
      </Accordion>
      <Accordion defaultActiveKey="1">
        <Accordion.Toggle
          eventKey="1"
          className="w-100 accordion-toggle"
          onClick={() => setIsOpenSharedCollection(!isOpenSharedCollection)}
        >
          <div className="title d-flex px-2">
            <span>Shared Collections</span>
            {isOpenSharedCollection ? <ChevronDownIcon className="icons" /> : <ChevronRightIcon className="icons" />}
          </div>
        </Accordion.Toggle>
        <Accordion.Collapse eventKey="1">
          <div>
            {
              props.collections
                .filter(clt => clt.sharedBy !== null && clt.sharedBy !== undefined)
                .map((collection, index) =>
                  <CollectionItem
                    key={`collection_${index}`}
                    collection={collection}
                    site={props.sites.find(site => site.collectionId === collection.id)}
                    onClick={() => onClickSharedItem(index, collection)}
                    onEdit={(e) => onEditSharedCollection(e, index, collection)}
                    selected={index === selectedSharedIndex}
                    Analytics={props.Analytics}
                  />
                )
            }
          </div>
        </Accordion.Collapse>
      </Accordion>
    </div>
  )
}

export default CollectionsListBox;
